export default "__VITE_ASSET__pJkrADtV__"